const DEFAULT_API_KEY_LENGTH = 48;

const encoder = new TextEncoder();

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

function randomString(length: number): string {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(bytes)
    .map((byte) => alphabet[byte % alphabet.length])
    .join("");
}

export async function sha256Hex(input: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", encoder.encode(input));
  return toHex(digest);
}

export async function hmacSha256Hex(
  secret: string,
  payload: string,
): Promise<string> {
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  const signature = await crypto.subtle.sign("HMAC", key, encoder.encode(payload));
  return toHex(signature);
}

export function generateAgentApiKey(
  prefix: string = "agnt_",
  length: number = DEFAULT_API_KEY_LENGTH,
): { apiKey: string; keyPrefix: string } {
  const token = randomString(length);
  const apiKey = `${prefix}${token}`;
  return {
    apiKey,
    keyPrefix: apiKey.slice(0, 12),
  };
}

export function generateWebhookSigningSecret(
  prefix: string = "whsec_",
  length: number = DEFAULT_API_KEY_LENGTH,
): string {
  return `${prefix}${randomString(length)}`;
}
